module.exports = __webpack_public_path__ + "static/media/cover9.d169b5b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/cover9.png
// module id = 562
// module chunks = 0